import {Pipe, PipeTransform} from '@angular/core';
import {EAction} from "../enums/EAction";

@Pipe({
  name: 'action'
})
export class ActionPipe implements PipeTransform {

  transform(value: EAction, ...args: unknown[]): unknown {
    return value === EAction.Add ? "Add" : "Edit";
  }

}
